import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';

/**
 * ConfirmationModal - A reusable confirmation modal component
 *
 * @param {boolean} show - Controls modal visibility
 * @param {function} onClose - Callback function when modal is closed/cancelled
 * @param {function} onConfirm - Callback function when user confirms the action
 * @param {string} title - Modal title text
 * @param {string} message - Main confirmation message
 * @param {string} description - Additional description/warning text
 * @param {boolean} isLoading - Shows loading state on confirm button
 * @param {string} confirmText - Text for confirm button (default: "Sì, Conferma")
 * @param {string} cancelText - Text for cancel button (default: "Annulla")
 * @param {string} confirmButtonClass - CSS class for confirm button (default: "btn-success")
 */
function ConfirmationModal({
  show,
  onClose,
  onConfirm,
  title = 'Conferma Azione',
  message = 'Sei sicuro di voler procedere?',
  description = 'Questa operazione non può essere annullata.',
  isLoading = false,
  confirmText = 'Sì, Conferma',
  cancelText = 'Annulla',
  confirmButtonClass = 'btn-success',
}) {
  if (!show) return null;

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                className="me-2 text-warning"
              />
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={isLoading}
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <p className="mb-3">
              <strong>{message}</strong>
            </p>
            {description && <p className="text-muted mb-0">{description}</p>}
          </div>
          <div className="modal-footer border-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={isLoading}
            >
              {cancelText}
            </button>
            <button
              type="button"
              className={`btn ${confirmButtonClass} px-4`}
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  />
                  Conferma in corso...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                  {confirmText}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;
